var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"illustration-wrapper",class:{ 'faded': _vm.faded, 'interactive': _vm.interactive, 'is-selected': _vm.selected, 'has-error': _vm.error }},[_c('inline-svg',{style:(`width: ${_vm.width}; min-width: ${_vm.minWidth}; max-width: ${_vm.maxWidth}`),attrs:{"src":_vm.illustration}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }